/**
 * Acciones para la edición de usuario en la gestión de usuarios para el rol supervisor
 * gu_eu_ = Gestión de Usuario (gu) _ Editar Usuario (eu)
 */
import {Dispatch} from 'react'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {State} from '../../../reducers'
import {
  generalOpenModalError,
  generalOpenModalMessage,
  generalShowLoader,
} from '../../general.actions'
import {GESTION_USUARIO_TYPES} from '../../../constants/gestionUsuario.types'
import {GestionUsuarioAction} from '../../../interfaces/gestion-usuarios.interace'
import {
  validacionesHandleChangeFacturador,
  validacionesOnBlurFacturador,
} from '../gu-generales/gu-generales'
import {KEYS} from '../../../constants/keysStorage'
import {ROL_POR_OMISION, resolverRolID} from '../../../constants/roles'

// ******************************************************************************************
const gu_eu_FormEditarHandleChange = (formUser: any) => ({
  type: GESTION_USUARIO_TYPES.EU_FORM_EDITAR_HANDLE_CHANGE,
  payload: formUser,
})

export const gu_eu_creacionUsuarioFormAddError = (error: any) => ({
  type: GESTION_USUARIO_TYPES.EU_FORM_EDITAR_ADD_ERROR,
  payload: error,
})

export const gu_eu_OpenModalEliminarUsuario = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.EU_SHOW_MODAL_ELIMINAR_USUARIO,
  payload: flag,
})

export const gu_eu_SetUsuarioSeleccionado = (usuario: any) => ({
  type: GESTION_USUARIO_TYPES.EU_SET_USUARIO_SELECCIONADO,
  payload: usuario,
})

export const gu_eu_Clear = () => ({
  type: GESTION_USUARIO_TYPES.EU_CLEAR,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const gu_eu_OpenEditar =
  (usuario: any) => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => usuario?.type_id_number === doc.codigo);

    await dispatch(gu_eu_SetUsuarioSeleccionado(usuario))
    let user = {
      username: usuario?.username || '',
      passwd: '',
      passwd2: '',
      birth_date: usuario?.birth_date || '',
      first_name: usuario?.first_name || '',
      second_name: usuario?.second_name || '',
      third_name: usuario?.third_name || '',
      last_name: usuario?.last_name || '',
      last_name2: usuario?.last_name2 || '',
      last_name_married: usuario?.last_name_married || '',
      nit: usuario?.nit || '',
      id_number: usuario?.id_number || '',
      codigo_empresa: usuario?.codigo_empresa || '',
      email: usuario?.email || '',
      phone_number: usuario?.phone_number || '',
      location: usuario?.location || '',
      role_access_user: String(resolverRolID(usuario?.role_access_user || ROL_POR_OMISION)),
      description: '',
      tipoDocumento: usuario?.type_id_number,
      nombreTipoDocumento: tipoDoc?.valor,
    }
    if (user.nit.length === 14 && !user.nit.includes('-')) {
      user.nit = `${user.nit.substring(0, 3)}-${user.nit.substring(4, 9)}-${user.nit.substring(
        10,
        13
      )}`
    }
    await dispatch(gu_eu_FormEditarHandleChange(user))
  }

export const gu_eu_FormEditarHandleChangeInputPhone =
  (phone: string) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    if (!validacionesHandleChangeFacturador('phone_number', phone)) return
    dispatch(gu_eu_FormEditarHandleChange({phone_number: phone}))
  }

export const gu_eu_FormEditarHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {name, value} = e.target

    if (!validacionesHandleChangeFacturador(name, value) && name !== 'id_number') return
      dispatch(gu_eu_FormEditarHandleChange({[name]: value}))
    
    switch (name) {
      case 'tipoDocumento':
        const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
        dispatch(gu_eu_FormEditarHandleChange({nombreTipoDocumento: tipoDoc.valor, id_number: ''}))
        break;
      case 'id_number':
        switch (getState().gestionUsuario.editarUsuario.formUser.nombreTipoDocumento?.toLowerCase()) {
          case 'dui':
            value = value.substring(0, 9);
            dispatch(gu_eu_FormEditarHandleChange({[name]: String(value).replace(/[^0-9\s\-]/g, "")}))
              break;
          case 'nit':
            dispatch(gu_eu_FormEditarHandleChange({[name]: String(value).replace(/[^0-9\s\-]/g, "")}))
              break;
          default:
            dispatch(gu_eu_FormEditarHandleChange({[name]: value.toUpperCase()}))
              break;
        }
        break
    }
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************

export const gu_eu_EditarUsuario =
  (history: any) => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const formUser = getState().gestionUsuario.editarUsuario.formUser

    // ================================================================================
    // Creación de Usuario
    const body = {
      username: formUser.username.trim(),
      passwd: formUser.passwd || null,
      birth_date: formUser.birth_date,
      first_name: formUser.first_name.trim(),
      second_name: formUser.second_name.trim(),
      third_name: formUser.third_name.trim(),
      last_name: formUser.last_name.trim(),
      last_name2: formUser.last_name2.trim(),
      last_name_married: formUser.last_name_married.trim(),
      nit: formUser.nit.trim(),
      type_id_number: formUser.tipoDocumento,
      id_number: formUser.id_number.trim(),
      email: formUser.email.trim(),
      phone_number: formUser.phone_number.trim(),
      location: formUser.location.trim(),
      role_access_user: resolverRolID(formUser.role_access_user || ROL_POR_OMISION),
    }
    let message =
      'Existió un inconveniente al editar la información del usuario, intente nuevamente'

    await http
      .post(ENDPOINTS.GESTION_USUARIO_UPDATE_USUARIO, body)
      .then(async (res: any) => {
        if (res.status === 200) {
          dispatch(
            generalOpenModalMessage(
              `Usuario Actualizado`,
              `Se actualizó la información del usuario`
            )
          )
          history.push('/gestion-usuarios/listar-usuarios')
          return
        }
        dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_eu_EliminarUsuarioConfirm =
  (history: any) => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const body = {
      admin_id: String(localStorage.getItem(KEYS.ID_CLIENT)), // ID Supervisor
      user_id: String(getState().gestionUsuario.editarUsuario.usuarioSeleccionado?.id), // ID Facturador
    }
    let message = 'Existió un problema al eliminar el usuario, inténtelo nuevamente'
    await http
      ._delete(ENDPOINTS.GESTION_USUARIO_DELETE_USUARIO, body)
      .then(async (res: any) => {
        if (res.status === 200) {
          await dispatch(
            generalOpenModalMessage(
              `Usuario Eliminado`,
              `El usuario ha sido eliminado exitosamente`
            )
          )
          await dispatch(generalShowLoader(false))
          await dispatch(gu_eu_OpenModalEliminarUsuario(false))
          await dispatch(gu_eu_SetUsuarioSeleccionado(null))
          history.push('/gestion-usuarios/listar-usuarios')
          return
        }
        dispatch(generalOpenModalError(res.message ?? message))
      })
      .catch((err: any) => {
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************

export const gu_eu_validacionesEditarUsuarioOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {name, value} = e.target;
    let message = validacionesOnBlurFacturador(name, value, getState().gestionUsuario.editarUsuario.formUser.nombreTipoDocumento)
  
    dispatch(gu_eu_creacionUsuarioFormAddError({[name]: message}))
  }

export const gu_eu_validacionesEditarUsuarioConfirm =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().gestionUsuario.editarUsuario
    let errors = {...formError}
    errors.username = validacionesOnBlurFacturador('username', formUser.username)

    if (formUser.passwd || formUser.passwd2) {
      errors.passwd = validacionesOnBlurFacturador('passwd', formUser.passwd)
      errors.passwd2 = validacionesOnBlurFacturador('passwd2', formUser.passwd2)
      if (formUser.passwd2 && formUser.passwd && formUser.passwd2 !== formUser.passwd)
        errors.passwd2 = 'Las contraseñas no coinciden'
    }

    errors.first_name = validacionesOnBlurFacturador('first_name', formUser.first_name)
    errors.second_name = validacionesOnBlurFacturador('second_name', formUser.second_name)
    errors.third_name = validacionesOnBlurFacturador('third_name', formUser.third_name)
    errors.last_name = validacionesOnBlurFacturador('last_name', formUser.last_name)
    errors.last_name2 = validacionesOnBlurFacturador('last_name2', formUser.last_name2)
    errors.last_name_married = validacionesOnBlurFacturador(
      'last_name_married',
      formUser.last_name_married
    )
    errors.phone_number = validacionesOnBlurFacturador('phone_number', formUser.phone_number)
    errors.location = validacionesOnBlurFacturador('location', formUser.location)
    errors.birth_date = validacionesOnBlurFacturador('birth_date', formUser.birth_date)
    errors.nit = validacionesOnBlurFacturador('nit', formUser.nit)
    errors.id_number = validacionesOnBlurFacturador('id_number', formUser.id_number)

    dispatch(gu_eu_creacionUsuarioFormAddError(errors))
    if (
      errors.username ||
      errors.passwd ||
      errors.passwd2 ||
      errors.birth_date ||
      errors.first_name ||
      errors.last_name ||
      errors.nit ||
      errors.id_number ||
      errors.email ||
      errors.phone_number
    )
      return true
    return false
  }
